import { FC, ReactNode } from 'react';
import { Box, Stack } from '@chakra-ui/react';

import styles from './HeaderMenuLinks.module.scss';

export interface HeaderMenuLinksProps {
  children: ReactNode;
  isOpen: boolean;
}

export const HeaderMenuLinks: FC<HeaderMenuLinksProps> = ({
  isOpen,
  children,
}) => (
  <Box
    bg={['brand.monochromatic.50', 'white']}
    className={styles.container}
    display={{ base: isOpen ? 'block' : 'none', md: 'block' }}
    flexBasis={{ base: '100%', md: 'auto' }}
    p={4}
  >
    <Stack
      spacing={6}
      align={['left', 'left', 'center']}
      justify={['center', 'space-between', 'flex-end', 'flex-end']}
      direction={['column', 'column', 'row', 'row']}
      pt={[4, 4, 0, 0]}
    >
      {children}
    </Stack>
  </Box>
);
